/**使用记录**/
<template>
  <div class="used">
    <div class="usedContent">
      <div v-if="couponsFn&&couponsFn.length">
        <xk-couponMod v-for="(item,index) in couponsFn"
                      :type="item.type"
                      :sum="item.sum"
                      :title="item.title"
                      :startTime="item.startTime"
                      :key="index"
                      :endTime="item.endTime"
                      :overdueTime="item.overdueTime"
                      :status="1"
                      :useState="2"
                      :couponType="item.couponType"
                      :serviceType="item.serviceType"
        >
        </xk-couponMod>
        <!--<div class="loadMoreBut" @click="loadMoreButFn"-->
        <!--v-if="couponData&&couponData.length<total">-->
        <!--<span>点击加载更多</span>-->
        <!--</div>-->
      </div>
      <div v-else="" class="jilv">
        <h2>暂无使用记录</h2>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Toucth from '../../../assets/js/method'

  export default {
    name: '',
    computed: {
      ...mapGetters({
        usedCoupons: 'usedCoupons',
        usedCouponGetter: 'usedCouponGetter',
        loginData: 'loginData'
      }),
      couponsFn: function () {
        let that = this
        let content = that.couponData
        let len = content && content.length > 0 ? content.length : 0
        this.total = len
        let list = []
        if (len > 0) {
          for (let i = 0; i < content.length; i++) {
            let obj = {
              type: 'daijia',
              title: '代驾专享',
              sum: 30,
              startTime: '2017-03-05',
              endTime: '2017-06-06',
              serviceType: ''
            }
            // switch (content[i].couponType) {
            //   case 1:
            //     obj.type = 'daijia'
            //     break
            //   case 'zhuanche':
            //     obj.type = 'zhuanche'
            //     break
            //   case 'paotui':
            //     obj.type = 'paotui'
            //     break
            //   case 'freight':
            //     obj.type = 'huoyun'
            //     break
            //   case 'xiche':
            //     obj.type = 'xiche'
            //     break
            //   case 'pinche':
            //     obj.type = 'pinche'
            //     break
            //   case 'zhuanxian':
            //     obj.type = 'zhuanxian'
            //     break
            //   case 'gasstation':
            //     obj.type = 'gasstation'
            //     break
            // }
            obj.title = content[i].title
            obj.startTime = Toucth.TimestampDate(content[i].begin_time).split(' ')[0]
            obj.endTime = Toucth.TimestampDate(content[i].end_time).split(' ')[0].indexOf('1970-01-01') < 0 ? Toucth.TimestampDate(content[i].end_time).split(' ')[0] : '永久有效'
            obj.sum = content[i].deductible ? content[i].deductible.toFixed(1) : content[i].discount / 10
            if (content[i].discount) {
              obj.couponType = 'discount'
            } else {
              obj.couponType = 'deduction'
            }
            if (content[i].main_service_type === 'daijia') {
              obj.serviceType = '代驾券'
            }
            console.log('pwqoroewireituiertrijuehgjfghj', obj)
            list.push(obj)
          }
        }
        return list
      }
    },
    data () {
      return {
        page: 1,
        rows: 10,
        total: 0,
        couponData: []
      }
    },
    methods: {
      loadMoreButFn: function () {
        let that = this
        that.page += 1
        that.$store.dispatch('getCouponType', {
          channel: 5,
          page: that.page,
          limit: 80,
          'fn': (data) => {
            that.loadState = false
            if (data && data.code === 1) {
              that.total = data.total
              let arr = []
              data.coupon.forEach(item => {
                if (item.state === 2) {
                  // var endTime = item.end_time
                  // if (endTime) {
                  //   if (new Date().valueOf() < endTime * 1000) {
                  //     arr.push(item)
                  //   }
                  // } else {
                  //   arr.push(item)
                  // }
                  arr.push(item)
                }
              })
              that.couponData = that.couponData.concat(...arr)
            }
          }
        })
      }
    },
    mounted: function () {
      let that = this
      that.loadState = true
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.$store.dispatch('v5getCoupons', {
            channel: 'system',
            page: 1,
            limit: 80,
            'fn': (data) => {
              that.loadState = false
              if (data && data.code === 1) {
                that.total = data.total
                let arr = []
                data.coupon.forEach(item => {
                  console.log(item)
                  if (Number(item.state) === 2) {
                    // var endTime = item.end_time
                    // if (endTime) {
                    //   if (new Date().valueOf() < endTime * 1000) {
                    //     arr.push(item)
                    //   }
                    // } else {
                    //   arr.push(item)
                    // }
                    arr.push(item)
                  }
                })
                // that.couponData = that.couponData.concat(...arr)
                that.couponData = arr
              } else {
                that.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: data.msg
                }
              }
            }
          })
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .used {
    box-sizing: border-box;
    padding: 0 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    .jilv {
      margin-top: 30vh;
      height: 40vh;
      text-align: center;
    }
  }


</style>



// WEBPACK FOOTER //
// used.vue?c291a294